<template>
  <div>
    <base-input label="Conditions">
      <button
        class="btn btn-sm btn-warning float-right"
        v-on:click="addCondition"
      >
        + Add Condition
      </button>
    </base-input>
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      bordered
      :key="tableConditionKey"
    >
      <template
        v-for="colSlot in ['source', 'code', 'operator', 'value']"
        :slot="colSlot"
        slot-scope="text, record"
      >
        <div :key="colSlot">
          <div v-if="colSlot == 'source'">
            <a-select
              v-if="record.editable"
              style="width: 100%"
              placeholder="Select field"
              @select="(e) => setCodeOptions(e, record.key, colSlot)"
              v-model="dataSource[record.key][colSlot]"
            >
              <a-select-option
                v-for="data in options.source"
                :key="data.code"
                :value="data.code"
                >{{ data.label }}</a-select-option
              >
            </a-select>
            <template v-else>{{ text }}</template>
          </div>
          <div v-if="colSlot == 'code'">
            <a-select
              v-if="record.editable"
              style="width: 100%"
              placeholder="Select field"
              v-model="dataSource[record.key][colSlot]"
            >
              <a-select-option
                v-for="data in dataSource[record.key]['codeOptions']"
                :key="data.code"
                :value="data.code"
                >{{ data.name }}</a-select-option
              >
            </a-select>
            <template v-else>{{ text }}</template>
          </div>
          <div v-if="colSlot == 'operator'">
            <a-select
              v-if="record.editable"
              style="width: 100%"
              placeholder="Select operation"
              v-model="dataSource[record.key][colSlot]"
            >
              <a-select-option
                v-for="operation in operations"
                :key="operation"
                :value="operation"
                >{{ operation }}</a-select-option
              >
            </a-select>
            <template v-else>{{ text }}</template>
          </div>
          <div v-if="colSlot == 'value'">
            <input
              v-if="record.editable"
              v-model="dataSource[record.key][colSlot]"
              style="margin: -5px 0"
            />
            <template v-else>{{ text }}</template>
          </div>
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a
              class="btn btn-sm btn-primary"
              style="color: white"
              @click="() => save(record.key)"
              >Save</a
            >
          </span>
          <span v-else>
            <a
              style="color: white"
              class="btn btn-sm btn-primary"
              @click="() => edit(record.key, 'conditions')"
              >Edit</a
            >
            <a-popconfirm
              title="Are you sure you want to delete this condition?"
              @confirm="() => deleteRecord(record, 'conditions')"
            >
              <a style="color: white" class="btn btn-sm btn-danger">Delete</a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    customFields: {
      type: Array,
      default: () => []
    },
    groupConditions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      operations: [
        'NOT NULL',
        'IS NULL',
        '=',
        '!=',
        '>=',
        '<=',
        '>',
        '<',
        'IN'
      ],
      tableConditionKey: 0,
      /**
       * columns handle object with the follwing keys
       * title - label of the column
       * dataIndex - code use of the column
       * width - pencentage width of the column
       * scopedSlots - slot use for rendering the column in row
       */
      columns: [
        {
          title: 'Source',
          dataIndex: 'source',
          width: '20%',
          scopedSlots: { customRender: 'source' }
        },
        {
          title: 'Code',
          dataIndex: 'code',
          width: '20%',
          scopedSlots: { customRender: 'code' }
        },
        {
          title: 'Operation',
          dataIndex: 'operator',
          width: '20%',
          scopedSlots: { customRender: 'operator' }
        },
        {
          title: 'Value',
          dataIndex: 'value',
          width: '20%',
          scopedSlots: { customRender: 'value' }
        },
        {
          title: '',
          dataIndex: 'operation',
          width: '20%',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      dataSource: [
        // {
        //   key: '0',
        //   source: null,
        //   code: null,
        //   operator: null,
        //   value: null,
        //   codeOptions: [],
        //   editable: true,
        //   save: false
        // }
      ],
      options: {
        source: [
          { code: 'SYSTEM', label: 'System' },
          { code: 'CUSTOM_FIELDS', label: 'Custom Fields' }
        ],
        systemDefault: [
          {
            code: 'membership_program',
            dataType: null,
            key: null,
            name: 'Membership Program'
          },
          {
            code: 'membership_level',
            dataType: null,
            key: null,
            name: 'Membership Level'
          }
        ],
        membershipPrograms: [],
        membershipLevels: []
      }
    };
  },
  async created() {
    if (this.groupConditions.length > 0) {
      let data = this.groupConditions;
      let x = 0;
      while (x < data.length) {
        if (data[x].codeOptions == undefined) {
          if (data[x].code == 'CUSTOM_FIELDS') {
            data[x]['codeOptions'] = this.customFields;
          }
          if (data[x].code == 'SYSTEM') {
            data[x]['codeOptions'] = this.options.systemDefault;
          }
        }
        x++;
      }
      this.dataSource = data;
    }
  },
  mounted() {},
  watch: {
    dataSource: function (val) {
      console.log(val);
    }
  },
  computed: {},
  methods: {
    save(row) {
      this.dataSource[row].editable = false;
      this.dataSource[row].save = true;
      // if (this.dataSource[row].code == 'membership_program') {
      //   if (this.options.systemDefault.length < 2) {
      //     this.options.systemDefault.push({
      //       code: 'membership_level',
      //       dataType: null,
      //       key: null,
      //       name: 'Membership Level'
      //     });
      //   }
      // }
      let data = this.dataSource[row];
      delete data['codeOptions'];
      this.$emit('save-condition', data);
    },
    edit(row) {
      this.dataSource[row].editable = true;
      this.dataSource[row].save = false;
    },
    deleteRecord(row) {
      this.$emit('remove-condition', this.dataSource[row.key]);
      this.dataSource[row.key].splice(row.key, 1);
    },
    setCodeOptions(e, record) {
      // this.dataSource[record][col] = e;
      if (this.dataSource[record]['codeOptions'] == undefined) {
        if (e == 'CUSTOM_FIELDS') {
          this.dataSource[record]['codeOptions'] = this.customFields;
        }
        if (e == 'SYSTEM') {
          this.dataSource[record]['codeOptions'] = this.options.systemDefault;
        }
      } else {
        if (e == 'CUSTOM_FIELDS') {
          this.dataSource[record]['codeOptions'] = this.customFields;
        }
        if (e == 'SYSTEM') {
          this.dataSource[record]['codeOptions'] = this.options.systemDefault;
        }
      }
      this.dataSource[record]['code'] = null;
    },
    addCondition() {
      this.dataSource.push({
        key: this.dataSource.length,
        source: null,
        code: null,
        operator: null,
        value: null,
        codeOptions: [],
        editable: true,
        save: false
      });
    }
  }
};
</script>
<style scoped></style>
